<template>
  <div v-show="visible" :style="{
    position: 'fixed',
    inset: '0',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: String(zIndex),
    pointerEvents: 'none'
  }" aria-hidden="true">
    <!-- 上 -->
    <div :style="maskStyle(0, 0, vw, Math.max(0, rect.top))" @click="outsideClick" />
    <!-- 下 -->
    <div :style="maskStyle(rect.top + rect.height, 0, vw, Math.max(0, vh - (rect.top + rect.height)))"
      @click="outsideClick" />
    <!-- 左 -->
    <div :style="maskStyle(rect.top, 0, Math.max(0, rect.left), rect.height)" @click="outsideClick" />
    <!-- 右 -->
    <div :style="maskStyle(rect.top, rect.left + rect.width, Math.max(0, vw - (rect.left + rect.width)), rect.height)"
      @click="outsideClick" />

    <!-- 裝飾框（不攔截事件，洞口內可互動） -->
    <div :style="{
      position: 'fixed',
      top: rect.top + 'px',
      left: rect.left + 'px',
      width: rect.width + 'px',
      height: rect.height + 'px',
      borderRadius: radius + 'px',
      boxShadow: '0 0 0 1px rgba(255,255,255,0.9), 0 0 24px 8px rgba(0,0,0,0.25)',
      pointerEvents: 'none',
      transition: 'top .08s, left .08s, width .08s, height .08s'
    }" />
  </div>
</template>

<script>
export default {
  name: 'SpotlightHole',
  props: {
    target: { type: [String, Object], required: true }, // selector 或 Element
    padding: { type: [Number, Object], default: 10 },
    radius: { type: Number, default: 12 },
    visible: { type: Boolean, default: true },
    zIndex: { type: Number, default: 50000 },
    backdropOpacity: { type: Number, default: 0.6 },    // 0~1
    closeOnOutside: { type: Boolean, default: true }
  },
  computed: {
    normalizedPadding() {
      if (typeof this.padding === 'number') {
        return {
          top: this.padding,
          right: this.padding,
          bottom: this.padding,
          left: this.padding
        }
      }
      return {
        top: this.padding.top || 0,
        right: this.padding.right || 0,
        bottom: this.padding.bottom || 0,
        left: this.padding.left || 0
      }
    }
  },
  data() {
    return {
      rect: { top: 0, left: 0, width: 0, height: 0 },
      vw: window.innerWidth,
      vh: window.innerHeight,
      ro: null,
      rafId: null
    }
  },
  watch: {
    target: {
      handler() {
        this.$nextTick(() => { this.detach(); this.attach() })
      },
      immediate: true
    },
    visible(v) {
      v ? this.attach() : this.detach()
    }
  },
  mounted() {
    if (this.visible) this.attach()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    this.detach()
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    getEl(t) {
      if (!t) return null
      if (typeof t === 'string') return document.querySelector(t)
      return t instanceof Element ? t : null
    },
    measure() {
      const el = this.getEl(this.target)
      if (!el) return
      const r = el.getBoundingClientRect()
      const p = this.normalizedPadding
      this.rect = {
        top: Math.max(0, r.top - p.top),
        left: Math.max(0, r.left - p.left),
        width: r.width + p.left + p.right,
        height: r.height + p.top + p.bottom
      }
    },
    handleScrollOrResize() {
      if (this.rafId) cancelAnimationFrame(this.rafId)
      this.rafId = requestAnimationFrame(() => {
        this.measure()
      })
    },
    handleResize() {
      this.vw = window.innerWidth
      this.vh = window.innerHeight
      this.handleScrollOrResize()
    },
    attach() {
      const el = this.getEl(this.target)
      if (!el) return
      this.measure()
      // 追蹤元素尺寸變化
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(() => this.handleScrollOrResize())
        this.ro.observe(el)
      }
      // 捕獲所有滾動（含可滾容器）
      window.addEventListener('scroll', this.handleScrollOrResize, true)
      window.addEventListener('resize', this.handleScrollOrResize)
    },
    detach() {
      window.removeEventListener('scroll', this.handleScrollOrResize, true)
      window.removeEventListener('resize', this.handleScrollOrResize)
      if (this.ro) { this.ro.disconnect(); this.ro = null }
      if (this.rafId) { cancelAnimationFrame(this.rafId); this.rafId = null }
    },
    outsideClick() {
      if (this.closeOnOutside) this.$emit('close')
    },
    maskStyle(top, left, width, height) {
      return {
        position: 'fixed',
        top: top + 'px',
        left: left + 'px',
        width: width + 'px',
        height: height + 'px',
        background: `rgba(0,0,0,${this.backdropOpacity})`,
        pointerEvents: 'auto'
      }
    }
  }
}
</script>
